import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './core/components/layout/main.component';
import { MxAuthGuard } from './core/guards/mx.auth.guard';

import { MxPreloadModulesStrategy } from './core/strategies/mx.preload-modules.strategy';

const app_routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: 'invoice',
        loadChildren: () =>
          import('./features/invoice/invoice.module').then(
            (m) => m.InvoiceModule
          ),
      },
      {
        path: 'invoice-report',
        loadChildren: () =>
          import('./features/invoice-report/invoice-report.module').then(
            (m) => m.InvoiceReportModule
          ),
      },
      {
        path: 'sales-report',
        loadChildren: () =>
          import('./features/sales-report/sales-report.module').then(
            (m) => m.SalesReportModule
          ),
      },
      {
        path: 'commitment-documents',
        loadChildren: () =>
          import('./features/commitment-documents/commitment-documents.module').then(
            (m) => m.CommitmentDocumentsModule
          ),
      },
      {
        path: 'product-certificate-documents',
        loadChildren: () =>
          import('./features/product-certificate-documents/product-certificate-documents.module').then(
            (m) => m.ProductCertificateDocumentsModule
          ),
      },
      {
        path: 'remaining-orders',
        loadChildren: () =>
          import('./features/remaining-orders/remaining-orders.module').then(
            (m) => m.RemainingOrdersModule
          ),
      },
      {
        path: 'partner-program-report',
        loadChildren: () =>
          import(
            './features/partner-program-report/partner-program-report.module'
          ).then((m) => m.PartnerProgramReportModule),
      },
      {
        path: 'np-dashboard',
        loadChildren: () =>
          import('./features/np-dashboard/np-dashboard.module').then(
            (m) => m.NPDashboardModule
          ),
      },
      {
        path: 'partner-program-assets',
        loadChildren: () =>
          import(
            './features/partner-program-assets/partner-program-assets.module'
          ).then((m) => m.PartnerProgramAssetsModule),
      },
      {
        path: 'sugo',
        loadChildren: () =>
          import('./features/help/help.module').then((m) => m.HelpModule),
      },
      {
        path: 'claims',
        loadChildren: () =>
          import('./features/claims/claims.module').then((m) => m.ClaimsModule),
      },
      {
        path: 'company-details',
        loadChildren: () =>
          import('./features/company-details/company-details.module').then(
            (m) => m.CompanyDetailsModule
          ),
      },
      {
        path: 'issue-reports',
        loadChildren: () =>
          import('./features/issue-reports/issue-reports.module').then(
            (m) => m.IssueReportsModule
          ),
      },
      {
        path: 'partner-contacts',
        loadChildren: () =>
          import('./features/partner-contacts/partner-contacts.module').then(
            (m) => m.PartnerContactsModule
          ),
      },
      {
        path: 'szirom-pont',
        loadChildren: () =>
          import('./features/loyalty-pharmacy/loyalty-pharmacy.module').then(
            (m) => m.LoyaltyPharmacyModule
          ),
      },
      {
        path: 'offers',
        loadChildren: () =>
          import('./features/offers/offers.module').then((m) => m.OffersModule),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'email-templates',
        loadChildren: () =>
          import('./features/email-templates/email-templates.module').then((m) => m.EmailTemplatesModule),
      },
      {
        path: 'email-log',
        loadChildren: () =>
          import('./features/email-log/email-log.module').then((m) => m.EmailLogModule),
      },
      {
        path: 'posts',
        loadChildren: () =>
          import('./features/posts/posts.module').then((m) => m.PostsModule),
      },
      {
        path: 'loyalty',
        loadChildren: () =>
          import('./features/loyalty/loyalty.module').then((m) => m.LoyaltyModule),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./features/subscriptions/subscriptions.module').then(
            (m) => m.SubscriptionsModule
          ),
      },
      {
        path: 'anthroposophy-subscriptions',
        loadChildren: () =>
          import(
            './features/anthroposophy-subscriptions/anthroposophy-subscriptions.module'
          ).then((m) => m.AnthroposophySubscriptionsModule),
      },
      {
        path: 'anthroposophy-products',
        loadChildren: () =>
          import(
            './features/anthroposophy-products/anthroposophy-products.module'
          ).then((m) => m.AnthroposophyProductsModule),
      },
      {
        path: 'work-schedule',
        loadChildren: () =>
          import('./features/work-schedule/work-schedule.module').then((m) => m.WorkScheduleModule),
      },
    ],
    canActivate: [MxAuthGuard],
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./core/components/pages/mx.pages-routing.module').then(
        (m) => m.MxPagesRoutingModule
      ),
  },
  { path: '**', redirectTo: '/pages/not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(app_routes, {
      preloadingStrategy: MxPreloadModulesStrategy,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [MxPreloadModulesStrategy],
})
export class AppRoutingModule { }
